import React, { useEffect } from 'react'
import { Box, Stack } from '@mui/material'
import { useSessionContext } from 'session'
import { LeadershipOfficerCreateCard } from 'components'

export const LeadershipOfficerCreatePage: React.FC = () => {
  const { changeModuleName, changeUniqueId } = useSessionContext()

  useEffect(() => {
    changeModuleName('Create Leadership Officer')
    changeUniqueId('')
  }, [changeModuleName, changeUniqueId])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        mt: 1
      }}
    >
      <Stack spacing={2} alignItems="center" mt={1} width="98%">
        <LeadershipOfficerCreateCard />
      </Stack>
    </Box>
  )
}
